var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-table-card-info" }, [
    _c("div", { staticClass: "tls-card-lg" }, [
      _c("table", { attrs: { "aria-label": "available appointment table" } }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "tls-table-head", attrs: { scope: "col" } },
              [_vm._v(_vm._s(_vm._.get(_vm.splashCMSData, "table_tourism")))]
            ),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "tls-table-head", attrs: { scope: "col" } },
              [_vm._v(_vm._s(_vm._.get(_vm.splashCMSData, "table_business")))]
            ),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "tls-table-head", attrs: { scope: "col" } },
              [_vm._v(_vm._s(_vm._.get(_vm.splashCMSData, "table_others")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(this.availableAppointments, function(appointment) {
            return _c("tr", [
              _c(
                "th",
                { staticClass: "tls-table-head", attrs: { scope: "row" } },
                [_vm._v(_vm._s(_vm._.get(appointment, "city")))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "tls-table-cell",
                  attrs: {
                    "data-visual-label": _vm._.get(
                      _vm.splashCMSData,
                      "table_tourism"
                    )
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.formatToLocalDate(
                          _vm._.get(appointment, "tourismVisaDate")
                        )
                      ) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "tls-table-cell",
                  attrs: {
                    "data-visual-label": _vm._.get(
                      _vm.splashCMSData,
                      "table_business"
                    )
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.formatToLocalDate(
                          _vm._.get(appointment, "businessVisaDate")
                        )
                      ) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "tls-table-cell",
                  attrs: {
                    "data-visual-label": _vm._.get(
                      _vm.splashCMSData,
                      "table_others"
                    )
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.formatToLocalDate(
                          _vm._.get(appointment, "othersVisaDate")
                        )
                      ) +
                      "\n                    "
                  )
                ]
              )
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }